import React, { Fragment, useEffect, useState } from 'react';
import Ad from '../../components/ad/ad';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';

const Wrapper = ({ children, combinedAdModel }) => (
  <div className="post post--default">
    <div className="post__main">
      <div className="post_reco">
        <div className="post__container post__container--long">
          <div className="post__content">
            <section className="finite-scroll__recommended-articles">
              <div className="articles">{children}</div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <div className="post__sidebar sticky">
      <Ad
        {...combinedAdModel}
        noLazyLoad={true}
        pos="btf"
        name="flexibleportrait"
        canRefresh={true}
      />
    </div>
  </div>
);

const RecommendedArticles = ({ articles = null, adSplit, combinedAdModel }) => {
  const [articleChunks, setArticleChunks] = useState([]);

  useEffect(() => {
    setArticleChunks(chunk(articles, adSplit));
  }, []);

  if (!articleChunks) return false;

  return (
    <Fragment>
      {articleChunks.map((articleChunk, i) => (
        <Fragment key={`articleChunk-${i}`}>
          {i !== 0 && (
            <div className="post__article-top-ad-wrapper">
              <Ad
                {...combinedAdModel}
                name="flexiblebillboard"
                region="articlescroll"
                ceros={false}
                pos="btf"
              />
              <Ad
                {...combinedAdModel}
                name="mobileleaderboard"
                region="articlescroll"
                pos="btf"
              />
            </div>
          )}

          <Wrapper
            group={i}
            key={`articleChunk-${i}`}
            combinedAdModel={combinedAdModel}
          >
            {articleChunk.map(article => (
              <article key={article.title}>
                <div className="image">
                  <a href={article.url}>
                    <img
                      src={article.image_url
                        .replace('.png', '.webp')
                        .replace('.jpg', '.webp')
                        .replace('w_1280', 'w_210')}
                      alt={article.title}
                    />
                  </a>
                </div>

                <div className="hed">
                  <div className="eyebrow">{article.section}</div>

                  <a href={article.url}>{article.title}</a>
                </div>
              </article>
            ))}
          </Wrapper>
        </Fragment>
      ))}
    </Fragment>
  );
};

RecommendedArticles.propTypes = {
  articles: PropTypes.shape([]).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  adSplit: PropTypes.number
};

Wrapper.propTypes = {
  combinedAdModel: PropTypes.shape({}).isRequired,
  group: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};

RecommendedArticles.defaultProps = {
  adSplit: 0
};

export default RecommendedArticles;
